<template>
  <div id="app">
    <el-header></el-header>
    <router-view />
    <el-footer></el-footer>
    <el-back></el-back>
  </div>
</template>

<script>
import ElHeader from "@/view/layout/Header";
import ElFooter from "@/view/layout/Footer";
import ElBack from "@/view/layout/Back";
export default {
  components: {
    ElHeader,
    ElFooter,
    ElBack,
  },
  name: "App",
  provide() {
    return {
    };
  },
  data() {
    return {
    };
  },
  methods: {
    
  },
};
</script>

<style>
:root {
  --base-width: 80%;
  --base-min-width: 1100px;
  --base-min-width-m: 100%;
  --fixed-width: 100%;
  @media only screen and (min-width: 300px) and (max-width: 768px) {
    --base-width: 90%;
  }
}
html,
body {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  height: 100vh;
  width: 100%;
  color: #333;
  overflow-x: hidden;
  min-width: var(--base-min-width);
}
@media only screen and (min-width: 300px) and (max-width: 768px) {
  html,body {
    min-width: var(--base-min-width-m);
  }
}
ul,li,p,h2,dl,dd,dt{
  margin: 0;
  padding: 0;
  list-style: none;
}
a{
  text-decoration: none;
  color: #333;
}
.html-img {
  max-width: 100%;
}
/* banner标题默认样式.jarallax-container */
.tit-fixed {
  position: fixed;
  top: 0;
  width: var(--fixed-width);
  height: 455px;
}
.tit-fixed .cst_container_base {
  margin: auto;
  padding: 210px 0 110px;
  width: var(--base-width);
  color: #fff;
}
.tit-fixed .cst_container_base h1 {
  line-height: 1.3em;
  margin-top: 0px;
  font-family: SiYuan-ExtraLight;
  margin-bottom: 5px;
  font-size: 36px;
  display: inline-block;
  font-weight: 200;
}
.tit-fixed .cst_container_base h2 {
  width: 80px;
  height: 1px;
  background: #fff;
  margin: 10px 0 20px 0;
}
.tit-fixed .cst_container_base h3 {
  line-height: 1.3em;
  font-family: Roboto;
  padding-left: 2px;
  padding-right: 2px;
  font-weight: lighter;
  font-size: 28px;
  font-weight: 200;
  margin: 0px;
}
.tit-fixed .cst_textbox_line {
  display: flex;
  margin-top: -15px;
  margin-bottom: 0px;
  background: #26a3de;
  margin: 0 auto;
  width: var(--base-width);
  height: 18px;
  border-radius: 4px;
}
.list-wrap {
  position: relative;
  padding-top: 0px;
  min-height: 20px;
}
.list-wrap .zhanwei {
  height: 455px;
}
.list-wrap .wrap {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue